<template>
  <div class="select-img-component">
    <el-dialog
      v-model="dialogVisible"
      :title="$t('lcd.Devices.Select AD Material')"
      width="90vw"
      :before-close="handleClose"
      :visible.sync="dialogVisible"
    >
      <div class="select-img">
        <el-table
          ref="singleTableRef"
          :data="dataList"
          style="width: 100%"
          height="70vh"
          highlight-current-row
          @current-change="handleCheck"
          border
        >
          <el-table-column type="index" width="50">
            <!-- <el-table-column type="selection" width="55" /> -->
            <el-table-column width="50">
              <template #default="scope">
                <div style="display: flex; align-items: center">
                  <el-radio-group v-model="currentRow.originalUrl">
                    <el-radio :label="scope.row.originalUrl" size="large"
                      ><span style="display: none">1</span></el-radio
                    >
                  </el-radio-group>
                </div>
              </template>
            </el-table-column>
          </el-table-column>

          <el-table-column
            prop="materialName"
            min-width="140"
            :label="$t('lcd.material.Material Name')"
            header-align="center"
          >
            <el-table-column prop="materialName" min-width="140" align="center">
              <template #header>
                <el-input
                  size="mini"
                  v-model="searchParams.materialName"
                  @change="getData"
                  placeholder=""
                  clearable
                ></el-input>
              </template>
            </el-table-column>
          </el-table-column>
          <!--  :label="
                ? $t('lcd.material.Material Image')
                : $t('lcd.material.Material Video')
            " -->
          <el-table-column
            prop="originalUrl"
            min-width="140"
            :label="$t('lcd.Devices.Material Preview')"
            header-align="center"
          >
            <el-table-column prop="originalUrl" min-width="140" align="center">
              <template #default="scope">
                <div class="show-img-bd">
                  <el-image
                    v-if="scope.row.format != 'mp4'"
                    :src="scope.row.originalUrl"
                    fit="contain"
                    :preview-src-list="[scope.row.originalUrl]"
                  >
                  </el-image>
                  <video v-else controls :src="scope.row.originalUrl"></video>
                </div>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            prop="pixels"
            :label="$t('images.Material Pixels')"
            min-width="120"
            header-align="center"
          >
            <el-table-column prop="pixels" min-width="120" align="center">
              <template #header>
                <el-select
                  v-model="searchParams.pixels"
                  placeholder=""
                  size="small"
                  @change="getData"
                  clearable
                  disabled
                >
                  <el-option
                    v-for="item in pixelsList"
                    :key="item"
                    :label="item"
                    :value="item"
                  >
                  </el-option>
                </el-select>
              </template>
            </el-table-column>
          </el-table-column>
          <el-table-column
            prop="size"
            :label="$t('images.Material Size')"
            header-align="center"
          >
            <el-table-column prop="size" align="center"> </el-table-column>
          </el-table-column>

          <el-table-column
            prop="format"
            :label="$t('images.Format')"
            width="110"
            header-align="center"
          >
            <el-table-column prop="format" width="110" align="center">
            </el-table-column>
          </el-table-column>
          <el-table-column
            prop="createTime"
            :label="$t('images.Create Time')"
            width="230"
            header-align="center"
          >
            <el-table-column prop="createTime" width="230" align="center">
            </el-table-column>
          </el-table-column>
        </el-table>

        <!-- 页码 -->
        <pagination :tableInfo="pageParams" @changePage="getData" />

        <div class="select-img-btn">
          <el-button size="small" @click="handleClose">{{
            $t("button.Cancel")
          }}</el-button>
          <el-button
            size="small"
            color="#28C76F"
            type="success"
            @click="handleSave"
            >{{ $t("button.Save") }}</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getMaterialList, getPixels } from "@/libs/api/lcd";
import pagination from "@/components/pagination";
export default {
  name: "imgSelect",
  components: {
    pagination,
  },
  props: {
    materialFlag: {
      type: String,
      default: "All",
    },
  },
  data() {
    return {
      dialogVisible: false,
      dataList: [],
      pixelsList: [],
      searchParams: {
        materialName: "",
        isEffect: "0",
        openType: "0,1,2,3,4",
        materialType: "0",
        pixels: "800*480",
      },
      initSearchParams: {
        materialName: "",
        isEffect: "0",
        openType: "0,1,2,3,4",
        materialType: "0",
        pixels: "800*480",
      },
      pageParams: {
        pixels: "800*480",
        state: "1", // 所有审核通过的素材
        current: 1, //当前页
        size: 10, //单页显示最大数
        total: 0,
        pageSizeArr: ["10", "20", "50", "100", "200", "500", "1000"],
      },
      currentRow: {
        originalUrl: "",
      },
      checked: false,
      loading: false,
    };
  },
  watch: {
    dialogVisible(val, oval) {
      if (val) {
        this.getData();
      }
    },
  },
  created() {
    this.getPixelsList();
  },
  methods: {
    open() {
      this.dialogVisible = true;
      this.currentRow = {
        originalUrl: "",
      };
    },
    getPixelsList() {
      getPixels().then((res) => {
        console.log(res);
        this.pixelsList = res.data.data;
      });
    },
    // 获取数据
    async getData() {
      this.dataList = [];
      try {
        let materialFlag = ''
        if(this.materialFlag == 'All') {
          materialFlag = ''
        } else if( this.materialFlag == 'Img'){
           materialFlag = 0
        } else {
          materialFlag = 1
        }
        const params = {
          ...this.searchParams,
          current: this.pageParams.current,
          size: this.pageParams.size, //10，20，50，100.
          materialType: materialFlag,
        };
        let { data } = await getMaterialList(params);
        if (data.state) {
          const list = data.data.records;
          this.dataList = list;
          this.pageParams.total = data.data.total;
        } else {
          this.$message.error(data.message);
          // alert(data.message)
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    // 时间选择change
    handleDateChange(val) {
      console.log("时间选择---", val);
      if (val) {
        this.searchParams.startDate = val[0];
        this.searchParams.endDate = val[1];
      } else {
        this.searchParams.startDate = "";
        this.searchParams.endDate = "";
      }

      this.getData();
    },
    // 表格单选
    handleCheck(val) {
      console.log("表格选中了...", val);
      if (val) this.currentRow = val;
    },
    // 关闭弹窗
    handleClose() {
      this.dataList = [];
      this.searchParams = this.initSearchParams;
      this.dialogVisible = false;
      console.log(this.searchParams);
    },
    // 点击保存
    handleSave() {
      const currentRow = this.currentRow;
      if (currentRow.originalUrl) {
        this.dialogVisible = false;
        this.searchParams = this.initSearchParams;
        this.dataList = [];
        this.$emit("doSelect", currentRow);
      } else {
        this.$message({
          message: this.$t("images.ErrorMessage3"),
          type: "warning",
        });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.select-img-component {
  ::v-deep .el-table__body-wrapper {
    // min-height: 400px;
    overflow-y: auto;
  }
  .select-img {
    // margin: 0 -100px;
    padding-bottom: 40px;
    margin-top: -10px;
  }
  .select-img-pagination {
    display: flex;
    justify-content: right;
    padding: 20px 0 50px;
  }
  .select-img-btn {
    // width: 200px;
    // margin: 0 auto;
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: 80px;
    background: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    // box-shadow: 0 0 4px rgb(0 0 0 / 30%);
    z-index: 99;
  }
  .custom-check {
    width: 18px;
    height: 18px;
    background: #ffffff;
    border: 1px solid #dddddd;
    border-radius: 4px;
  }
  .show-img-bd {
    display: flex;
    flex-direction: column;
  }
  .show-img {
    width: 20px;
    height: 20px;
  }

  // 重置样式
  ::v-deep .el-table--border .el-table__cell {
    border-right: 1px solid #ebeef5 !important;
  }
  ::v-deep .el-dialog {
    margin-top: 5vh !important;
  }
  ::v-deep .el-date-editor.el-input__inner {
    width: 206px;
  }
  ::v-deep .el-button {
    width: 100px;
  }
  ::v-deep .el-table__row {
    cursor: pointer;
  }
}
</style>